import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  AccordionSummaryProps,
  styled,
} from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { FC } from "react";

type AccordionMenuProps = {
  children?: any;
  title: string;
  handleChange: Function;
  expandedItem?: string | boolean;
  accordionHeader: string | JSX.Element;
};

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  marginBottom: 1,
  color: theme.palette.text.secondary,
  backgroundColor: "transparent",
  borderRadius: 7,
  "&:before": { display: "none" },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    {...props}
    expandIcon={
      <KeyboardArrowDownRoundedIcon
        sx={{ fontSize: 16, color: "text.disabled" }}
      />
    }
  />
))(({ theme }) => ({
  padding: "7px 10px",
  borderRadius: 7,
  minHeight: 32,
  color: theme.palette.text.secondary,
  transition: "background-color 120ms ease, color 120ms ease",
  "& .MuiSvgIcon-root": { color: theme.palette.text.secondary },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": { color: theme.palette.text.primary },
  },
  "&.Mui-expanded": {
    color: theme.palette.text.primary,
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transition: "transform 150ms ease",
  },
}));

const AccordionMenu: FC<AccordionMenuProps> = ({
  title,
  children,
  expandedItem,
  handleChange,
  accordionHeader,
}) => {
  return (
    <Accordion
      square={false}
      disableGutters
      elevation={0}
      expanded={expandedItem === title}
      onChange={handleChange(title)}
      sx={{ left: "0 !important" }}
    >
      <AccordionSummary>{accordionHeader}</AccordionSummary>
      <MuiAccordionDetails sx={{ p: "2px 0 4px" }}>
        {children}
      </MuiAccordionDetails>
    </Accordion>
  );
};

export default AccordionMenu;
